export const videoURL_ko = 'https://youtu.be/xfcMCMPd6Gw'
export const videoURL_en = 'https://youtu.be/xoZWB-kckpk'
